module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/qr-intelect-dom-43706bf8c3265a271a843d5c36e0c326.svg";